import { WorkspaceSession } from "@/types/workspace";

const SESSION_KEY = "workspace_session";
const INACTIVITY_TIMEOUT = 30 * 30 * 1000; // 30 minutes

export class WorkspaceSessionManager {
  static getSession(): WorkspaceSession | null {
    try {
      const session = localStorage.getItem(SESSION_KEY);
      if (!session) return null;

      const parsedSession = JSON.parse(session) as WorkspaceSession;
      const now = Date.now();

      if (now > parsedSession.expiresAt ||
          now - parsedSession.lastActivityAt > INACTIVITY_TIMEOUT) {
        this.clearSession();
        return null;
      }

      return parsedSession;
    } catch {
      return null;
    }
  }

  static setSession(workspaceId: string): void {
    const session: WorkspaceSession = {
      workspaceId,
      expiresAt: Date.now() + INACTIVITY_TIMEOUT,
      lastActivityAt: Date.now()
    };
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  }

  static updateActivity(): void {
    const session = this.getSession();
    if (session) {
      this.setSession(session.workspaceId);
    }
  }

  static clearSession(): void {
    localStorage.removeItem(SESSION_KEY);
  }
}
